export default "__VITE_ASSET__DWZ6JhrE__"